import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import Splide from '@splidejs/splide';
import { Fancybox } from "@fancyapps/ui/dist/fancybox/fancybox.esm.js";
import Cookies from 'js-cookie';
const mapIcon = 'https://dentalimplantsgps.com/wp-content/themes/bridge-child/resources/images/gps_map_icon_c.png';

var ready = (callback) => {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
}

ready(() => {

    const rootfontsize = getComputedStyle(document.documentElement).fontSize;
    
    // desktop hamburger menu button
    document.querySelector(".dsktphamburger").addEventListener("click", (e) => {
        const main_menu = document.getElementsByClassName("main_menu")[0];
        if (main_menu) {
            main_menu.classList.toggle("active");
        };
    });

    // desktop close menu button
    document.querySelector(".closenav").addEventListener("click", (e) => {
        const main_menu = document.getElementsByClassName("main_menu")[0];
        if (main_menu) {
            main_menu.classList.toggle("active");
        };
    });

    //desktop mega menu subheads, prevent click
    document.querySelector(".sub-menu-head a").addEventListener("click", (e) => {
        e.preventDefault()
    });

    // mobile hamburger menu button
    document.querySelector(".mobile_menu_button_two").addEventListener("click", (e) => {
        const mobile_menu = document.getElementsByClassName("main-mobile-menu")[0];
        const mobile_menu_close = document.getElementsByClassName("closemobile")[0];
        if (mobile_menu) {
            mobile_menu.classList.toggle("active");
            mobile_menu_close.classList.toggle("active");
        };
    });

    // close mobile menu button
    document.querySelector(".closemobile__inner").addEventListener("click", (e) => {
        const mobile_menu = document.getElementsByClassName("main-mobile-menu")[0];
        const mobile_menu_close = document.getElementsByClassName("closemobile")[0];
        if (mobile_menu) {
            mobile_menu.classList.toggle("active");
            mobile_menu_close.classList.toggle("active");
        };
    });

    // close main menu outside of menu
    window.addEventListener('click', function(e){
        if (!document.getElementById('main_menu').contains(e.target) && !document.getElementById('hamburgerdsktp').contains(e.target)) {
            if (document.getElementById('main_menu').classList.contains('active')) {
               document.getElementById('main_menu').classList.remove('active');
            }
        }

        if (!document.getElementById('mobile_menu').contains(e.target) && !document.getElementById('hamburgermob').contains(e.target)) {

            const mobile_menu = document.getElementsByClassName("main-mobile-menu")[0];
            const mobile_menu_close = document.getElementsByClassName("closemobile")[0];
            if (mobile_menu) {
                mobile_menu.classList.remove("active");
                mobile_menu_close.classList.remove("active");
            };
        }
    });

    //header banner

    // const bannerwrap = document.querySelector(".bannerouterwrap");
    // var ctaBannerClick = document.querySelectorAll('.ctabarlink');
    // let initview = Cookies.get('initview');
    // let mobileviewport = window.innerWidth < 768;
    // const closeBtn = document.querySelector(".bannerclosebtn");
    

    // if (bannerwrap && !initview) {
    //     Cookies.set('initview', 'true', { expires: 1 }); // Set cookie to expire in 1 day
    //     setTimeout(showBanner, 1000);
    //     setTimeout(hideBanner, 9000);
    // }

    // if (bannerwrap && !mobileviewport) {
    //     // Add hover event listeners to the banner itself
    //     bannerwrap.addEventListener('mouseenter', showBanner);
    //     bannerwrap.addEventListener('mouseleave', hideBanner);

    //     closeBtn.addEventListener('click', hideBanner);
    // }

    // if (closeBtn) {
    //     closeBtn.addEventListener('click', hideBanner);
    // }

    // // Add hover event listeners to ctaBannerClick elements
    // // ctaBannerClick.forEach(element => {
    // //     element.addEventListener('mouseenter', showBanner);
    // //     element.addEventListener('mouseleave', hideBanner);
    // // });

    // // Add click event listeners to ctaBannerClick elements
    // ctaBannerClick.forEach(element => {
    //     element.addEventListener('click', toggleBanner);
    // });

    // function toggleBanner() {
    //     bannerwrap.classList.toggle("open");
    // }

    // function showBanner() {
    //     bannerwrap.classList.add("open");
    // }

    // function hideBanner() {
    //     bannerwrap.classList.remove("open");
    // }

    // // trustslider
    const trustslider = document.getElementsByClassName("trustslider")[0];

    console.log('here');
    if (trustslider) {
        Cookies.set('initview', true);
        var trustsplide = new Splide('.trustslider', {
            type: 'loop',
            perPage: 3,
            perMove: 1,
            arrow: true,
            gap: 20, 
            pagination: false,
            arrows: true,
            autoplay: false,
            interval: 3000,
            breakpoints: {
                850: {
                    perPage: 1,
                    height: '280px',
                },
            },
        });

        trustsplide.mount();

      //  Cookies.set('trustvisited', true);
    }

    const initSliderPos = 95;
    var rangeinput = document.getElementById("slider");
    let initrange = 0

    if (rangeinput) {
        rangeinput.value = initSliderPos;

        // 938w x 744h  

        const beforeaftermob = document.getElementsByClassName("beforeaftermob")[0];
        const beforeafterimgbk = document.getElementsByClassName("background-img")[0];
        const beforeafterimgfore = document.getElementsByClassName("foreground-img")[0];
        
        resizeMobBeforeAfter();

        window.addEventListener("resize", resizeMobBeforeAfter);

        jQuery("#slider").on("input change", (e) => {
            const sliderPos = e.target.value;
            // Update the width of the foreground image
            jQuery('.foreground-img').css('width', `${sliderPos}%`)
            jQuery('.forecallouts').css('width', `${sliderPos}%`)
            // Update the position of the slider button
            jQuery('.slider-button').css('left', `calc(${sliderPos}% - 17px)`)

            // if (sliderPos < 50) {
            //     if (initrange == 0) {
            //         initrange = 1
            //         finishMobBeforeAfter();
            //     }
            // }
        });

        function resizeMobBeforeAfter() {
            let winWidth = window.innerWidth;
            let divimgbkWidth = winWidth / 938;
            let divimgbkHeight = divimgbkWidth * 744;

            beforeaftermob.style.height = `${divimgbkHeight}px`;
            beforeafterimgbk.style.height = `${divimgbkHeight}px`;
            beforeafterimgfore.style.height = `${divimgbkHeight}px`;
        }
    }

    // Desktop callouts

    var homeBeforeAfter = document.querySelectorAll('.homebeforeafter');

    // If homebeforeafter exists
    if (homeBeforeAfter.length > 0) {

        var callouts = document.querySelectorAll('.calloutcirc');

        callouts.forEach(el => el.addEventListener('click', event => {

            const intPairs = {
                dskcirc1: 'dskcirc8',
                dskcirc2: 'dskcirc9',
                dskcirc3: 'dskcirc10',
                dskcirc4: 'dskcirc11',
                dskcirc5: 'dskcirc12',
                dskcirc6: 'dskcirc13',
                dskcirc7: 'dskcirc14',
                dskcirc8: 'dskcirc1',
                dskcirc9: 'dskcirc2',
                dskcirc10: 'dskcirc3',
                dskcirc11: 'dskcirc4',
                dskcirc12: 'dskcirc5',
                dskcirc13: 'dskcirc6',
                dskcirc14: 'dskcirc7'
            }

            let idnum = event.currentTarget.id;
            let clickedEl = document.getElementById(idnum);
            let pairedEl = document.getElementById(intPairs[idnum]);

            clickedEl.classList.toggle("active");
            pairedEl.classList.toggle("active");

        }));

        const initialDelay = 0.3
        const delay = 1
        let leftinterval
        let rightinterval
        let leftcloseinterval
        let rightcloseinterval
        let leftindx = 0
        let rightindx = 7
        let lefthideindx = 0
        let righthideindx = 7
        const classnames = ['one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen']

        // initial show
        setTimeout(() => {

            leftinterval = setInterval(() => {
                let calloutel = document.getElementsByClassName(classnames[leftindx])[0];
                calloutel.classList.toggle("active");
                leftindx++
                if (leftindx >= 7)
                    clearInterval(leftinterval);
            }, delay * 500)
        }, initialDelay * 500)

        setTimeout(() => {

            rightinterval = setInterval(() => {
                let calloutel = document.getElementsByClassName(classnames[rightindx])[0];
                calloutel.classList.toggle("active");
                rightindx++
                if (rightindx >= 14)
                    clearInterval(rightinterval);
            }, delay * 500)
        }, initialDelay * 500)


        // initial hide
        setTimeout(() => {

            leftcloseinterval = setInterval(() => {
                let calloutel = document.getElementsByClassName(classnames[lefthideindx])[0];
                calloutel.classList.remove("active");
                lefthideindx++
                if (lefthideindx >= 7)
                    clearInterval(leftcloseinterval);
            }, 100)
        }, 10000)

        setTimeout(() => {

            rightcloseinterval = setInterval(() => {
                let calloutel = document.getElementsByClassName(classnames[righthideindx])[0];
                calloutel.classList.remove("active");
                righthideindx++
                if (righthideindx >= 14)
                    clearInterval(rightcloseinterval);
            }, 100)
        }, 10000)


      //  setTimeout(() => {
       //     let scheduleconsul = document.getElementsByClassName('scheduleconsul')[0];
        //    scheduleconsul.classList.add("active");
       // }, 11000)

        // Mobile callouts

        var callouts = document.querySelectorAll('.calloutcircmob');

        callouts.forEach(el => el.addEventListener('click', event => {
            const hasClass = event.target.classList.contains('calloutcircmob');


            if (hasClass) {
                event.target.classList.toggle("active");
            } else {
                event.target.parentElement.classList.toggle("active");
            }
        }));

        // let mobinterval
        // let mobintervaltwo
        // let mobindx = 0
        // let mobindxtwo = 0
        // const mobclassnames = ['mobone', 'mobtwo', 'mobthree', 'mobfour', 'mobfive', 'mobsix', 'mobseven']
        // const mobclassnamestwo = ['mobeight', 'mobnine', 'mobten', 'mobeleven', 'mobtwelve', 'mobthirteen', 'mobfourteen']

        // // Left side callouts
        // setTimeout(() => {
        //     // call your func here
        //     mobinterval = setInterval(() => {
        //         let mobcalloutel = document.getElementsByClassName(mobclassnames[mobindx])[0];
        //         mobcalloutel.classList.toggle("active");
        //         if (mobindx >= 6)
        //             clearInterval(mobinterval);
        //         mobindx++
        //     }, delay * 1000)
        // }, initialDelay * 1000)

        // // Right side callouts after swipe
        // function finishMobBeforeAfter() {
        //     setTimeout(() => {
        //         // call your func here
        //         mobintervaltwo = setInterval(() => {
        //             let mobcallouteltwo = document.getElementsByClassName(mobclassnamestwo[mobindxtwo])[0];
        //             mobcallouteltwo.classList.toggle("active");
        //             mobindxtwo++
        //             if (mobindxtwo >= 7)
        //                 clearInterval(mobintervaltwo);

        //         }, delay * 1000)
        //     }, initialDelay * 200)
        // }

        // Home hero before after mobile
        var btnafter = document.querySelectorAll('.btnafter');
        var btnbefore = document.querySelectorAll('.btnbefore');
        var mobhomesplideel = document.querySelectorAll('.mobhomesplide');
        if (mobhomesplideel.length > 0) {
            var mobhomesplide = new Splide('.mobhomesplide', {
                perPage: 1,
                perMove: 1,
                type: 'slide',
                // classes: {
                //     arrows: 'splide__arrows homeloc-arrows',
                //     arrow : 'splide__arrow homeloc-arrow',
                //     prev  : 'splide__arrow--prev homeloc-prev',
                //     next  : 'splide__arrow--next homeloc-next',
                // },
                pagination: false,
                arrows: false,
            });

            mobhomesplide.on( 'move', function (newIndex, oldIndex, destIndex) {
                console.log(destIndex);
            } );

            mobhomesplide.mount();

            btnafter.forEach(el => el.addEventListener('click', event => {
                event.preventDefault()
                mobhomesplide.go( 1 );
            }));

            btnbefore.forEach(el => el.addEventListener('click', event => {
                event.preventDefault()
                mobhomesplide.go( 0 );
            }));
        }


    }

    jQuery(".leadblue .frm_button_submit").html(window.submitOneText);
    jQuery(".factsmythsright .frm_button_submit").html(window.submitTwoText);
    jQuery(".factsmyths .frm_button_submit").html(window.submitText).addClass("blueback");
    jQuery(".factsmyths .frm_button_submit").parent().addClass("center");

    var homethreegrid = document.querySelectorAll('.homethreegrid');

    if (homethreegrid.length > 0) {
        let testHomegridPos = isScrolledIntoView(homethreegrid);
        let initialHomeGridDelay = 300
        const stepdelay = 0.3
        let homeGridinterval
        let indx = 1

        if (testHomegridPos == true) {

            setTimeout(() => {
                // call your func here
                homeGridinterval = setInterval(() => {
                    let calloutel = document.getElementById('homegrid' + indx);
                    calloutel.querySelector(".vc_column-inner").classList.add("active");
                    indx++
                    if (indx >= 4)
                        clearInterval(homeGridinterval);
                }, stepdelay * 1000)
            }, initialHomeGridDelay)

        } else {

            let initScroll = false
            window.addEventListener('scroll', function(e) {
                let watchHomegridPos = isScrolledIntoView(homethreegrid);
                if (watchHomegridPos == true && initScroll == false) {

                    initScroll = true
                    initialHomeGridDelay = 0
                    setTimeout(() => {
                        // call your func here
                        homeGridinterval = setInterval(() => {
                            let calloutel = document.getElementById('homegrid' + indx);
                            calloutel.querySelector(".vc_column-inner").classList.add("active");
                            indx++
                            if (indx >= 4)
                                clearInterval(homeGridinterval);
                        }, stepdelay * 1000)
                    }, initialHomeGridDelay)
                }
            }, false);
        }

        let homegrid1 = document.getElementById('homegrid1');
        homegrid1.addEventListener('click', function(e) {
            e.preventDefault();
            window.location.href = "/solutions-for-denture-wearers/";
        });

        let homegrid2 = document.getElementById('homegrid2');
        homegrid2.addEventListener('click', function(e) {
            e.preventDefault();
            window.location.href = "/solutions-for-missing-and-failing-teeth/";
        });

        let homegrid3 = document.getElementById('homegrid3');
        homegrid3.addEventListener('click', function(e) {
            e.preventDefault();
            window.location.href = "/zygomatic-implants/";
        });

    }

    // home mobile before after
    var homeBeforeAfterMob = document.querySelectorAll('.beforeaftermob');

    if (homeBeforeAfterMob.length > 0) {

        let homemoblfthead = document.getElementById('homemoblfthead');
        let homemoblftimg = document.getElementById('homemoblftimg');
        let homemobrthead = document.getElementById('homemobrthead');
        let homemobrtimg = document.getElementById('homemobrtimg');
        let homeBeforeAfterMobPos = isScrolledIntoView(homeBeforeAfterMob);
        let curheroimg = Cookies.get('heromob');

        if (curheroimg == undefined) {
          Cookies.set('heromob', 1)
        } else {
          if (curheroimg  == 1) {
            curheroimg = 2;
          } else if (curheroimg  == 2) {
            curheroimg = 1;
          }
          Cookies.set('heromob', curheroimg.toString())
        }

        if (curheroimg == 1) {
            homemoblftimg.src = '/wp-content/themes/bridge-child/resources/images/homemob_before_mark.png';
            homemobrtimg.src = '/wp-content/themes/bridge-child/resources/images/homemob_after_mark.png';
        } else if (curheroimg == 2) {
            homemoblftimg.src = '/wp-content/themes/bridge-child/resources/images/homemob_before_marissa.png';
            homemobrtimg.src = '/wp-content/themes/bridge-child/resources/images/homemob_after_marissa.png';
        }


        if (homeBeforeAfterMobPos == true) {

            runBeforeAfterMob();

        } else {

            let initHomeBeforeAfterMobScroll = false

            window.addEventListener('scroll', function(e) {
                let homeBeforeAfterMobScrollPos = isScrolledIntoView(homeBeforeAfterMob);

                if (homeBeforeAfterMobScrollPos == true && initHomeBeforeAfterMobScroll == false) {
                    initHomeBeforeAfterMobScroll = true

                    runBeforeAfterMob();

                }

            }, false);

        }

        function runBeforeAfterMob() {
            let initialHomeBeforeAfterMobDelay = 0
            const stepdelay = 0.3
            let homeBeforeAfterMobintervalLeft;
            let homeBeforeAfterMobintervalRight;

            setTimeout(() => {
                // call your func here
                homeBeforeAfterMobintervalLeft = setInterval(() => {

                    homemoblfthead.classList.add("active");
                    homemoblftimg.classList.add("active");
                    clearInterval(homeBeforeAfterMobintervalLeft);

                }, 200);

            }, initialHomeBeforeAfterMobDelay)

            setTimeout(() => {
                // call your func here
                homeBeforeAfterMobintervalRight = setInterval(() => {

                    homemobrthead.classList.add("active");
                    homemobrtimg.classList.add("active");
                    clearInterval(homeBeforeAfterMobintervalRight);

                }, 600);

            }, initialHomeBeforeAfterMobDelay)
        }

    }

    // home benefits circle grid

    var benefitsgrid = document.querySelectorAll('.benefitsgrid');

    if (benefitsgrid.length > 0) {

        let benfitsHomeGridPos = isScrolledIntoView(benefitsgrid);

        if (benfitsHomeGridPos == true) {

            runHomeBenefitsGrid();

        } else {

            let initHomeBenefitsScroll = false

            window.addEventListener('scroll', function(e) {
                let watchHomeBenefitsGridPos = isScrolledIntoView(benefitsgrid);

                if (watchHomeBenefitsGridPos == true && initHomeBenefitsScroll == false) {
                    initHomeBenefitsScroll = true

                    runHomeBenefitsGrid();

                }
            }, false);

        }

    }

    function runHomeBenefitsGrid() {
        let initialBenefitsGridDelay = 0
        const gridstepdelay = 0.5
        let homeBenefitsGridinterval
        let benecircindx = 1
        let homeBenefitsIconinterval
        let beneiconindx = 1
        let homeBenefitsTextinterval
        let benetextindx = 1

        setTimeout(() => {
            // call your func here
            homeBenefitsGridinterval = setInterval(() => {

                let benefitscircel = document.getElementById('iconcirc' + benecircindx);
                benefitscircel.classList.add("active");

                benecircindx++
                if (benecircindx >= 7)
                    clearInterval(homeBenefitsGridinterval);
            }, gridstepdelay * 1000)

        }, initialBenefitsGridDelay)


        setTimeout(() => {
            // call your func here
            homeBenefitsIconinterval = setInterval(() => {

                let benefitsiconel = document.getElementById('icon' + beneiconindx);
                benefitsiconel.classList.add("active");

                beneiconindx++
                if (beneiconindx >= 7)
                    clearInterval(homeBenefitsIconinterval);
            }, gridstepdelay * 1000)

        }, initialBenefitsGridDelay + 400)

        setTimeout(() => {
            // call your func here
            homeBenefitsTextinterval = setInterval(() => {

                let benefitstextel = document.getElementById('icontext' + benetextindx);
                benefitstextel.classList.add("active");

                benetextindx++
                if (benetextindx >= 7)
                    clearInterval(homeBenefitsTextinterval);
            }, gridstepdelay * 1000)

        }, initialBenefitsGridDelay + 700)
    }


    // costscircle grid
    var costsgrid = document.querySelectorAll('.costsgrid');

    if (costsgrid.length > 0) {

        let costsHomeGridPos = isScrolledIntoView(costsgrid);

        if (costsHomeGridPos == true) {

            runHomeCostsGrid();

        } else {

            let initCostsScroll = false

            window.addEventListener('scroll', function(e) {
                let watchCostsGridPos = isScrolledIntoView(costsgrid);

                if (watchCostsGridPos == true && initCostsScroll == false) {
                    initCostsScroll = true

                    runHomeCostsGrid();

                }
            }, false);

        }

    }

    function runHomeCostsGrid() {
        let initialCostsGridDelay = 0
        const costsgridstepdelay = 0.5
        let costsGridinterval
        let costscircindx = 1
        let costsIconinterval
        let costsiconindx = 1
        let costsTextinterval
        let coststextindx = 1

        setTimeout(() => {
            // call your func here
            costsGridinterval = setInterval(() => {

                let costscircel = document.getElementById('iconcirc' + costscircindx);
                costscircel.classList.add("active");

                costscircindx++
                if (costscircindx >= 5)
                    clearInterval(costsGridinterval);
            }, costsgridstepdelay * 1000)

        }, initialCostsGridDelay)


        setTimeout(() => {
            // call your func here
            costsIconinterval = setInterval(() => {

                let costsiconel = document.getElementById('icon' + costsiconindx);
                costsiconel.classList.add("active");

                costsiconindx++
                if (costsiconindx >= 7)
                    clearInterval(costsIconinterval);
            }, costsgridstepdelay * 1000)

        }, initialCostsGridDelay + 400)

        setTimeout(() => {
            // call your func here
            costsTextinterval = setInterval(() => {

                let coststextel = document.getElementById('icontext' + coststextindx);
                coststextel.classList.add("active");

                coststextindx++
                if (coststextindx >= 7)
                    clearInterval(costsTextinterval);
            }, costsgridstepdelay * 1000)

        }, initialCostsGridDelay + 700)
    }

    // specialists grid

    var specialistsgrid = document.querySelectorAll('.specialistsgrid');

    if (specialistsgrid.length > 0) {

        let costsSpecialistsGridPos = isScrolledIntoView(specialistsgrid);

        if (costsSpecialistsGridPos == true) {

            runHomeSpecialistsGrid();

        } else {

            let initSpecialistsScroll = false

            window.addEventListener('scroll', function(e) {
                let watchSpecialistsGridPos = isScrolledIntoView(specialistsgrid);

                if (watchSpecialistsGridPos == true && initSpecialistsScroll == false) {
                    initSpecialistsScroll = true

                    runHomeSpecialistsGrid();

                }
            }, false);

        }

    }

    function runHomeSpecialistsGrid() {
        let initialSpecialistsGridDelay = 0
        const specialistsgridstepdelay = 0.5
        let specialistsGridinterval
        let specialistscircindx = 1
        let specialistsIconinterval
        let specialistsiconindx = 1
        let specialistsTextinterval
        let specialiststextindx = 1

        setTimeout(() => {
            // call your func here
            specialistsGridinterval = setInterval(() => {

                let specialistscircel = document.getElementById('iconcirc' + specialistscircindx);
                specialistscircel.classList.add("active");

                specialistscircindx++
                if (specialistscircindx >= 6)
                    clearInterval(specialistsGridinterval);
            }, specialistsgridstepdelay * 1000)

        }, initialSpecialistsGridDelay)


        setTimeout(() => {
            // call your func here
            specialistsIconinterval = setInterval(() => {

                let specialistsiconel = document.getElementById('icon' + specialistsiconindx);
                specialistsiconel.classList.add("active");

                specialistsiconindx++
                if (specialistsiconindx >= 6)
                    clearInterval(specialistsIconinterval);
            }, specialistsgridstepdelay * 1000)

        }, initialSpecialistsGridDelay + 400)

        setTimeout(() => {
            // call your func here
            specialistsTextinterval = setInterval(() => {

                let specialiststextel = document.getElementById('icontext' + specialiststextindx);
                specialiststextel.classList.add("active");

                specialiststextindx++
                if (specialiststextindx >= 6)
                    clearInterval(specialistsTextinterval);
            }, specialistsgridstepdelay * 1000)

        }, initialSpecialistsGridDelay + 700)
    }


    // comparison grid

    var comparisongrid = document.querySelectorAll('.comparisongrid');

    if (comparisongrid.length > 0) {

        let comparisonGridPos = isScrolledIntoView(comparisongrid);

        if (comparisonGridPos == true) {

            runComparisonGrid();

        } else {

            let initComparisonScroll = false

            window.addEventListener('scroll', function(e) {
                let watchComparisonGridPos = isScrolledIntoView(comparisongrid);

                if (watchComparisonGridPos == true && initComparisonScroll == false) {
                    initComparisonScroll = true

                    runComparisonGrid();

                }
            }, false);

        }

    }

    function runComparisonGrid() {
        let initialComparisonGridDelay = 0
        const comparisongridstepdelay = 0.5
        let comparisonGridinterval
        let comparisoncircindx = 1
        let comparisonIconinterval
        let comparisoniconindx = 1
        let comparisonTextinterval
        let comparisontextindx = 1

        setTimeout(() => {
            // call your func here
            comparisonGridinterval = setInterval(() => {

                let comparisoncircel = document.getElementById('iconcirc' + comparisoncircindx);
                comparisoncircel.classList.add("active");

                comparisoncircindx++
                if (comparisoncircindx >= 6)
                    clearInterval(comparisonGridinterval);
            }, comparisongridstepdelay * 1000)

        }, initialComparisonGridDelay)


        setTimeout(() => {
            // call your func here
            comparisonIconinterval = setInterval(() => {

                let comparisoniconel = document.getElementById('icon' + comparisoniconindx);
                comparisoniconel.classList.add("active");

                comparisoniconindx++
                if (comparisoniconindx >= 6)
                    clearInterval(comparisonIconinterval);
            }, comparisongridstepdelay * 1000)

        }, initialComparisonGridDelay + 400)

        setTimeout(() => {
            // call your func here
            comparisonTextinterval = setInterval(() => {

                let comparisontextel = document.getElementById('icontext' + comparisontextindx);
                comparisontextel.classList.add("active");

                comparisontextindx++
                if (comparisontextindx >= 6)
                    clearInterval(comparisonTextinterval);
            }, comparisongridstepdelay * 1000)

        }, initialComparisonGridDelay + 700)
    }


    // costscircle grid

    var costsgrid = document.querySelectorAll('.costsgrid');

    if (costsgrid.length > 0) {

        let costsHomeGridPos = isScrolledIntoView(costsgrid);

        if (costsHomeGridPos == true) {

            runHomeCostsGrid();

        } else {

            let initCostsScroll = false

            window.addEventListener('scroll', function(e) {
                let watchCostsGridPos = isScrolledIntoView(costsgrid);

                if (watchCostsGridPos == true && initCostsScroll == false) {
                    initCostsScroll = true

                    runHomeCostsGrid();

                }
            }, false);

        }

    }

    function runHomeCostsGrid() {
        let initialCostsGridDelay = 0
        const costsgridstepdelay = 0.5
        let costsGridinterval
        let costscircindx = 1
        let costsIconinterval
        let costsiconindx = 1
        let costsTextinterval
        let coststextindx = 1

        setTimeout(() => {
            // call your func here
            costsGridinterval = setInterval(() => {

                let costscircel = document.getElementById('iconcirc' + costscircindx);
                costscircel.classList.add("active");

                costscircindx++
                if (costscircindx >= 5)
                    clearInterval(costsGridinterval);
            }, costsgridstepdelay * 1000)

        }, initialCostsGridDelay)


        setTimeout(() => {
            // call your func here
            costsIconinterval = setInterval(() => {

                let costsiconel = document.getElementById('icon' + costsiconindx);
                costsiconel.classList.add("active");

                costsiconindx++
                if (costsiconindx >= 5)
                    clearInterval(costsIconinterval);
            }, costsgridstepdelay * 1000)

        }, initialCostsGridDelay + 400)

        setTimeout(() => {
            // call your func here
            costsTextinterval = setInterval(() => {

                let coststextel = document.getElementById('icontext' + coststextindx);
                coststextel.classList.add("active");

                coststextindx++
                if (coststextindx >= 5)
                    clearInterval(costsTextinterval);
            }, costsgridstepdelay * 1000)

        }, initialCostsGridDelay + 700)
    }

    // specialists grid

    var specialistsgrid = document.querySelectorAll('.specialistsgrid');

    if (specialistsgrid.length > 0) {

        let costsSpecialistsGridPos = isScrolledIntoView(specialistsgrid);

        if (costsSpecialistsGridPos == true) {

            runHomeSpecialistsGrid();

        } else {

            let initSpecialistsScroll = false

            window.addEventListener('scroll', function(e) {
                let watchSpecialistsGridPos = isScrolledIntoView(specialistsgrid);

                if (watchSpecialistsGridPos == true && initSpecialistsScroll == false) {
                    initSpecialistsScroll = true

                    runHomeSpecialistsGrid();

                }
            }, false);

        }

    }

    function runHomeSpecialistsGrid() {
        let initialSpecialistsGridDelay = 0
        const specialistsgridstepdelay = 0.5
        let specialistsGridinterval
        let specialistscircindx = 1
        let specialistsIconinterval
        let specialistsiconindx = 1
        let specialistsTextinterval
        let specialiststextindx = 1

        setTimeout(() => {
            // call your func here
            specialistsGridinterval = setInterval(() => {

                let specialistscircel = document.getElementById('iconcirc' + specialistscircindx);
                specialistscircel.classList.add("active");

                specialistscircindx++
                if (specialistscircindx >= 6)
                    clearInterval(specialistsGridinterval);
            }, specialistsgridstepdelay * 1000)

        }, initialSpecialistsGridDelay)


        setTimeout(() => {
            // call your func here
            specialistsIconinterval = setInterval(() => {

                let specialistsiconel = document.getElementById('icon' + specialistsiconindx);
                specialistsiconel.classList.add("active");

                specialistsiconindx++
                if (specialistsiconindx >= 6)
                    clearInterval(specialistsIconinterval);
            }, specialistsgridstepdelay * 1000)

        }, initialSpecialistsGridDelay + 400)

        setTimeout(() => {
            // call your func here
            specialistsTextinterval = setInterval(() => {

                let specialiststextel = document.getElementById('icontext' + specialiststextindx);
                specialiststextel.classList.add("active");

                specialiststextindx++
                if (specialiststextindx >= 6)
                    clearInterval(specialistsTextinterval);
            }, specialistsgridstepdelay * 1000)

        }, initialSpecialistsGridDelay + 700)
    }

    
    // value grid

    var valuegrid = document.querySelectorAll('.valuegrid');

    if (valuegrid.length > 0) {

        let valueGridPos = isScrolledIntoView(valuegrid);

        if (valueGridPos == true) {

            runValueGrid();

        } else {

            let initValueScroll = false

            window.addEventListener('scroll', function(e) {
                let watchValueGridPos = isScrolledIntoView(valuegrid);

                if (watchValueGridPos == true && initValueScroll == false) {
                    initValueScroll = true

                    runValueGrid();

                }
            }, false);

        }

    }

    function runValueGrid() {
        let initialValueGridDelay = 0
        const valuegridstepdelay = 0.5
        let valueGridinterval
        let valuecircindx = 1
        let valueIconinterval
        let valueiconindx = 1
        let valueTextinterval
        let valuetextindx = 1

        setTimeout(() => {
            // call your func here
            valueGridinterval = setInterval(() => {

                let valuecircel = document.getElementById('iconcirc' + valuecircindx);
                valuecircel.classList.add("active");

                valuecircindx++
                if (valuecircindx >= 6)
                    clearInterval(valueGridinterval);
            }, valuegridstepdelay * 1000)

        }, initialValueGridDelay)


        setTimeout(() => {
            // call your func here
            valueIconinterval = setInterval(() => {

                let valueiconel = document.getElementById('icon' + valueiconindx);
                valueiconel.classList.add("active");

                valueiconindx++
                if (valueiconindx >= 6)
                    clearInterval(valueIconinterval);
            }, valuegridstepdelay * 1000)

        }, initialValueGridDelay + 400)

        setTimeout(() => {
            // call your func here
            valueTextinterval = setInterval(() => {

                let valuetextel = document.getElementById('icontext' + valuetextindx);
                valuetextel.classList.add("active");

                valuetextindx++
                if (valuetextindx >= 6)
                    clearInterval(valueTextinterval);
            }, valuegridstepdelay * 1000)

        }, initialValueGridDelay + 700)
    }



    // lab grid

    var labgrid = document.querySelectorAll('.labgrid');

    if (labgrid.length > 0) {

        let labGridPos = isScrolledIntoView(labgrid);

        if (labGridPos == true) {

            runLabGrid();

        } else {

            let initLabScroll = false

            window.addEventListener('scroll', function(e) {
                let watchLabGridPos = isScrolledIntoView(labgrid);

                if (watchLabGridPos == true && initLabScroll == false) {
                    initLabScroll = true

                    runLabGrid();

                }
            }, false);

        }

    }

    function runLabGrid() {
        let initialLabGridDelay = 0
        const labgridstepdelay = 0.5
        let labGridinterval
        let labcircindx = 1
        let labIconinterval
        let labiconindx = 1
        let labTextinterval
        let labtextindx = 1

        setTimeout(() => {
            // call your func here
            labGridinterval = setInterval(() => {

                let labcircel = document.getElementById('iconcirc' + labcircindx);
                labcircel.classList.add("active");

                labcircindx++
                if (labcircindx >= 6)
                    clearInterval(labGridinterval);
            }, labgridstepdelay * 1000)

        }, initialLabGridDelay)


        setTimeout(() => {
            // call your func here
            labIconinterval = setInterval(() => {

                let labiconel = document.getElementById('icon' + labiconindx);
                labiconel.classList.add("active");

                labiconindx++
                if (labiconindx >= 6)
                    clearInterval(labIconinterval);
            }, labgridstepdelay * 1000)

        }, initialLabGridDelay + 400)

        setTimeout(() => {
            // call your func here
            labTextinterval = setInterval(() => {

                let labtextel = document.getElementById('icontext' + labtextindx);
                labtextel.classList.add("active");

                labtextindx++
                if (labtextindx >= 6)
                    clearInterval(labTextinterval);
            }, labgridstepdelay * 1000)

        }, initialLabGridDelay + 700)
    }


    // bone issues grid

    var boneissuesgrid = document.querySelectorAll('.boneissuesgrid');

    if (boneissuesgrid.length > 0) {

        let boneissuesGridPos = isScrolledIntoView(boneissuesgrid);


        if (boneissuesGridPos == true) {

            runBoneIssuesGrid();

        } else {

            let initBoneIssuesScroll = false

            window.addEventListener('scroll', function(e) {
                let watchBoneIssuesGridPos = isElementXPercentInViewport(boneissuesgrid);

                if (watchBoneIssuesGridPos == true && initBoneIssuesScroll == false) {
                    initBoneIssuesScroll = true

                    runBoneIssuesGrid();

                }
            }, false);

        }

    }

    function runBoneIssuesGrid() {
        let initialBoneIssuesGridDelay = 0
        const boneissuesgridstepdelay = 0.5
        let boneIssuesGridinterval
        let boneIssuescircindx = 1
        let boneIssuesIconinterval
        let boneIssuesiconindx = 1
        let boneIssuesTextinterval
        let boneIssuestextindx = 1
        let boneIssuesHeadinterval
        let boneIssuesheadindx = 1

        setTimeout(() => {
            // call your func here
            boneIssuesGridinterval = setInterval(() => {

                let boneissuescircel = document.getElementById('iconcirc' + boneIssuescircindx);
                boneissuescircel.classList.add("active");

                boneIssuescircindx++
                if (boneIssuescircindx >= 4)
                    clearInterval(boneIssuesGridinterval);
            }, boneissuesgridstepdelay * 1000)

        }, initialBoneIssuesGridDelay)


        setTimeout(() => {
            // call your func here
            boneIssuesIconinterval = setInterval(() => {

                let boneissuesiconel = document.getElementById('icon' + boneIssuesiconindx);
                boneissuesiconel.classList.add("active");

                boneIssuesiconindx++
                if (boneIssuesiconindx >= 4)
                    clearInterval(boneIssuesIconinterval);
            }, boneissuesgridstepdelay * 1000)

        }, initialBoneIssuesGridDelay + 400)

        setTimeout(() => {
            // call your func here
            boneIssuesTextinterval = setInterval(() => {

                let boneissuestextel = document.getElementById('icontext' + boneIssuestextindx);
                boneissuestextel.classList.add("active");

                boneIssuestextindx++
                if (boneIssuestextindx >= 4)
                    clearInterval(boneIssuesTextinterval);
            }, boneissuesgridstepdelay * 1000)

        }, initialBoneIssuesGridDelay + 700)

        setTimeout(() => {
            // call your func here
            boneIssuesHeadinterval = setInterval(() => {

                let boneissuesheadel = document.getElementById('head' + boneIssuesheadindx);
                boneissuesheadel.classList.add("active");

                boneIssuesheadindx++
                if (boneIssuesheadindx >= 4)
                    clearInterval(boneIssuesHeadinterval);
            }, boneissuesgridstepdelay * 1000)

        }, initialBoneIssuesGridDelay + 700)
    }

    // consul grid

    var consulgrid = document.querySelectorAll('.consulgrid');

    if (consulgrid.length > 0) {

        let consulGridPos = isScrolledIntoView(consulgrid);

        if (consulGridPos == true) {

            runConsulGrid();

        } else {

            let initConsulScroll = false

            window.addEventListener('scroll', function(e) {
                let watchConsulGridPos = isScrolledIntoView(consulgrid);

                if (watchConsulGridPos == true && initConsulScroll == false) {
                    initConsulScroll = true

                    runConsulGrid();

                }
            }, false);

        }

    }

    function runConsulGrid() {
        let initialConsulGridDelay = 0
        const consulgridstepdelay = 0.5
        let consulGridinterval
        let consulindx = 1

        setTimeout(() => {
            // call your func here
            consulGridinterval = setInterval(() => {

                let consulel = document.getElementById('consulicon' + consulindx);
                consulel.classList.add("active");

                consulel.addEventListener('mouseover', function(e) {
                    e.target.parentElement.classList.remove("active");
                  });

                consulel.addEventListener('mouseout', function(e) {
                    e.target.parentElement.classList.add("active");
                });

                consulel.addEventListener('click', function(e) {
                    e.preventDefault();
                });

                consulindx++
                if (consulindx >= 5)
                    clearInterval(consulGridinterval);
            }, consulgridstepdelay * 1000)

        }, initialConsulGridDelay)

    }


    // daysaway grid

    var daysaway = document.querySelectorAll('.daysaway');

    if (daysaway.length > 0) {

        let daysAwayPos = isScrolledIntoView(daysaway);

        if (daysAwayPos == true) {

            runDaysAway();

        } else {

            let initDaysAwayScroll = false

            window.addEventListener('scroll', function(e) {
                let watchDaysAwayPos = isScrolledIntoView(daysaway);

                if (watchDaysAwayPos == true && initDaysAwayScroll == false) {
                    initDaysAwayScroll = true

                    runDaysAway();

                }
            }, false);

        }

        function runDaysAway() {
            let initialDaysAwayDelay = 0
            const daysawaystepdelay = 0.5
            let daysAwayinterval
            let daysawayindx = 1

            setTimeout(() => {
                // call your func here
                daysAwayinterval = setInterval(() => {
    
                    let daysawayel = document.getElementById('daysaway' + daysawayindx);
                    daysawayel.classList.add("active");
    
                    daysawayindx++
                    if (daysawayindx >= 9)
                        clearInterval(daysAwayinterval);
                }, daysawaystepdelay * 1000)
    
            }, initialDaysAwayDelay)
        }

    }

    var daysawaymob = document.querySelectorAll('.daysawaymob');

    if (daysawaymob.length > 0) {

        let daysAwayMobPos = isScrolledIntoView(daysawaymob);

        if (daysAwayMobPos == true) {

            runDaysAwayMob();

        } else {

            let initDaysAwayMobScroll = false

            window.addEventListener('scroll', function(e) {
                let watchDaysAwayMobPos = isScrolledMobIntoView(daysawaymob);

                if (watchDaysAwayMobPos == true && initDaysAwayMobScroll == false) {
                    initDaysAwayMobScroll = true

                    runDaysAwayMob();

                }
            }, false);

        }

        function runDaysAwayMob() {
            let initialDaysAwayMobDelay = 0
            const daysawaymobstepdelay = 0.5
            let daysAwayMobinterval
            let daysawaymobindx = 1

            setTimeout(() => {
                // call your func here
                daysAwayMobinterval = setInterval(() => {
    
                    let daysawaymobel = document.getElementById('daysawaymob' + daysawaymobindx);
                    daysawaymobel.classList.add("active");
    
                    daysawaymobindx++
                    if (daysawaymobindx >= 9)
                        clearInterval(daysAwayMobinterval);
                }, daysawaymobstepdelay * 1000)
    
            }, initialDaysAwayMobDelay)
        }

    }

    // full arch grid

    var fullflow = document.querySelectorAll('.fullarchworkflowinner');

    if (fullflow.length > 0) {

        let fullarchworkPos = isScrolledIntoView(fullflow);

        if (fullarchworkPos == true) {

            runFullArchWorkFlow();

        } else {

            let initFullArchWorkScroll = false

            window.addEventListener('scroll', function(e) {
                let watchFullArchWorkPos = isElementXPercentInViewport(fullflow);

                if (watchFullArchWorkPos == true && initFullArchWorkScroll == false) {
                    initFullArchWorkScroll = true

                    runFullArchWorkFlow();

                }
            }, false);

        }

        function runFullArchWorkFlow() {
            let initialFullArchWorkDelay = 0
            const fullarchworkstepdelay = 0.5
            let fullArchWorkInterval
            let fullarchworkindx = 1

            let fullarchworktrack = document.getElementById('flowtrack');
            fullarchworktrack.classList.add("active");

            setTimeout(() => {
                // call your func here
                fullArchWorkInterval = setInterval(() => {
    
                    let fullarchworkel = document.getElementById('step' + fullarchworkindx);
                    fullarchworkel.classList.add("active");
    
                    fullarchworkindx++
                    if (fullarchworkindx >= 7)
                        clearInterval(fullArchWorkInterval);
                }, fullarchworkstepdelay * 1000)
    
            }, initialFullArchWorkDelay)
        }

    }

    // health risks chart
    
    var healthrisks = document.querySelectorAll('.healthrisksgraph');

    if (healthrisks.length > 0) {

        let healthrisksPos = isScrolledIntoView(healthrisks);

        if (healthrisksPos == true) {

            runHealthRisks();

        } else {

            let initHealthRisksScroll = false

            window.addEventListener('scroll', function(e) {
                let watchHealthRisksPos = isElementXPercentInViewport(healthrisks);

                if (watchHealthRisksPos == true && initHealthRisksScroll == false) {
                    initHealthRisksScroll = true

                    runHealthRisks();

                }
            }, false);

        }

        function runHealthRisks() {
            let initialHealthRisksDelay = 0
            const fullhealthrisksstepdelay = 0.4
            let healthRisksInterval;
            let healthRisksindx = 1

            console.log('run health risks chart');

            setTimeout(() => {
                // call your func here
                healthRisksInterval = setInterval(() => {
    
                    let healthriskel = document.getElementById('bartop-' + healthRisksindx);
                    healthriskel.classList.add("active");

                    let healthriskelbot = document.getElementById('barbottom-' + healthRisksindx);
                    healthriskelbot.classList.add("active");

                    if (healthRisksindx <= 3) {
                        let graphbarlabel = document.getElementById('label-' + healthRisksindx);
                        graphbarlabel.classList.add("active");
                    }
    
                    healthRisksindx++
                    if (healthRisksindx >= 10)
                        clearInterval(healthRisksInterval);
                }, fullhealthrisksstepdelay * 700)
    
            }, initialHealthRisksDelay)
        }

    }

    // health source toggle

    var healthsources = document.querySelectorAll('.healthsources');

    if (healthsources.length > 0) {

        var viewsources = document.querySelectorAll('.viewsources');
        var sourcestext = document.querySelectorAll('.sourcestext');

        viewsources.forEach(el => el.addEventListener('click', event => {
            event.preventDefault();

            if (sourcestext[0].classList.contains('active')) {
                sourcestext[0].classList.remove('active');
                viewsources[0].classList.remove('active');
            } else {
                sourcestext[0].classList.add('active');
                viewsources[0].classList.add('active');
            }

        }));

    }


    // bio items

    var biowrap = document.querySelectorAll('.biowrap');

    if (biowrap.length > 0) {
        
        var morebuttons = document.querySelectorAll('.morebutton');

        morebuttons.forEach(el => el.addEventListener('click', event => {
            event.preventDefault()
            event.currentTarget.parentNode.parentNode.classList.toggle("active");


        }));

    }

    // faq items

    var faqsouter = document.querySelectorAll('.faqsouter');

    if (faqsouter.length > 0) {
        
        var faqs = document.querySelectorAll('.faq');

        faqs.forEach(el => el.addEventListener('click', event => {
            event.preventDefault()
            event.currentTarget.classList.toggle("active");
        }));

    }

    // jump links

    if (window.location.href.indexOf("gps-specialist-team/#") > -1) {
        let hash = window.location.hash.substring(1);
        let bioel = document.getElementById(hash);
        let curScroll = document.documentElement.scrollTop;
        let w = window.innerWidth;
        let animheight = 150;
        if (w < 850) {
            animheight = -10;
        }
        bioel.classList.add("active");
        curScroll = curScroll + animheight;
        window.scrollTo({top: curScroll, behavior: 'smooth'});
    }

    //survey map
    var surveymapwrap = document.querySelectorAll('.surveymapwrap');
    if (surveymapwrap.length > 0) {

        const viewport = window.innerWidth;
        let coordinates = '/wp-content/themes/bridge-child/scripts/coordinates.json';
        let zoom = 5.65;
        let center = [-115.6893562, 35.35];

        if (viewport < 640) {
            coordinates = '/wp-content/themes/bridge-child/scripts/mob_coordinates.json';
            zoom = 5.3;
            center = [-116.6893562, 35.30];
        }

        mapboxgl.accessToken =
            "pk.eyJ1IjoidXBwZXJob3VzZSIsImEiOiJjazFpOHdzanoxaW5zM21wZGx2ZHRqM2R4In0.Ahjx7eaAqipeYaYLYCWjZA";
        const map = new mapboxgl.Map({
                container: 'surveymap',
                // Choose from Mapbox's core styles, or make your own style with Mapbox Studio
                style: "mapbox://styles/mapbox/light-v11",
                center: center,
                interactive: false,
                zoom: zoom
            });

            map.on('load', () => {
                fetch(coordinates)
                    .then(response => response.json())
                    .then(data => {
                        map.addSource('places', {
                            'type': 'geojson',
                            'data': data
                        });
        
                        map.addLayer({
                            'id': 'places',
                            'type': 'circle',
                            'source': 'places',
                            'paint': {
                                'circle-color': ['get', 'color'],
                                'circle-radius': 4,
                                'circle-stroke-width': 1,
                                'circle-stroke-color': '#ffffff'
                            }
                        });
                    })
                    .catch(error => console.error('Error loading locations:', error));
            });


    }
    // homeLocations map

    var homeLocations = document.querySelectorAll('.homemapcolleft');
    var homelocationinnerwrap = document.querySelectorAll('.homelocationinnerwrap');
    var backtolist = document.querySelectorAll('.backtolist');
    let curLoc = '';

    if (homeLocations.length > 0) {


        mapboxgl.accessToken =
            "pk.eyJ1IjoidXBwZXJob3VzZSIsImEiOiJjazFpOHdzanoxaW5zM21wZGx2ZHRqM2R4In0.Ahjx7eaAqipeYaYLYCWjZA";
        const map = new mapboxgl.Map({
            container: "map",
            // Choose from Mapbox's core styles, or make your own style with Mapbox Studio
            style: "mapbox://styles/mapbox/light-v11",
            center: [-117.906454, 33.654739],
            zoom: 8.8,
            interactive: false,
        });
        map.scrollZoom.disable();


        map.on("load", () => {

            backtolist.forEach(el => el.addEventListener('click', event => {
                event.preventDefault()
                homelocationinnerwrap[0].classList.remove("active");
                map.setPaintProperty('polygon1', 'fill-opacity', 0);
                map.setPaintProperty('polygon2', 'fill-opacity', 0);
                map.setPaintProperty('polygon3', 'fill-opacity', 0);
                map.setPaintProperty('polygon4', 'fill-opacity', 0);
                map.setPaintProperty('polygon5', 'fill-opacity', 0);
                map.setPaintProperty('polygon6', 'fill-opacity', 0);
                map.setPaintProperty('polygon7', 'fill-opacity', 0);
            }));

        });


        var homemapinview = document.querySelectorAll('.homemap');

        let homeMapPos = isScrolledIntoView(homemapinview);
        let initHomeMapScroll = false

        if (homeMapPos == true) {

           // loadHomeMap(map);

        } else {

            window.addEventListener('scroll', function(e) {
                let watchHomeMapPos = isScrolledIntoView(homemapinview);

                if (watchHomeMapPos == true && initHomeMapScroll == false) {
                    initHomeMapScroll = true

                   // loadHomeMap(map);

                }

            }, false);
        }

        function loadHomeMap(map) {

            // Dana Point
            const locOnePointLatLng = [-117.7231871, 33.4943349];

            function locationOne() {
                map.loadImage(mapIcon, (error, image) => {
                    if (error) throw error;
                    map.addImage("custom-marker1", image);
                    // Add a GeoJSON source with 2 points
                    map.addSource("points1", {
                        type: "geojson",
                        data: {
                            type: "FeatureCollection",
                            features: [{
                                // feature for Dana Point
                                type: "Feature",
                                geometry: {
                                    type: "Point",
                                    coordinates: locOnePointLatLng,
                                },
                            }, ],
                        },
                    });

                    // Add a symbol layer
                    map.addLayer({
                        id: "points1",
                        type: "symbol",
                        source: "points1",
                        layout: {
                            "icon-image": "custom-marker1",
                            // get the title name from the source's "title" property
                            "text-field": ["get", "title"],
                            "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
                            "text-offset": [0, 1.25],
                            "text-anchor": "top",
                        },
                    });
                });

                map.addSource(
                    "polygon1",
                    createGeoJSONCircle(locOnePointLatLng, 30.0)
                );
    
                map.addLayer({
                    id: "polygon1",
                    type: "fill",
                    source: "polygon1",
                    layout: {},
                    paint: {
                        "fill-color": "#34658d",
                        "fill-opacity": 0,
                    },
                });

                let locone = document.querySelector(".locone");
                setTimeout(function() {
                    locone.classList.add("active");
                }, 200);

                setTimeout(function() {
                    locone.classList.remove("active");
                }, 800);

            }

            // Huntington Beach
            const locTwoPointLatLng = [-117.9928712, 33.7014531];

            function locationTwo() {
                map.loadImage(mapIcon, (error, image) => {
                    if (error) throw error;
                    map.addImage("custom-marker2", image);
                    // Add a GeoJSON source with 2 points
                    map.addSource("points2", {
                        type: "geojson",
                        data: {
                            type: "FeatureCollection",
                            features: [{
                                // feature for Huntington Beach
                                type: "Feature",
                                geometry: {
                                    type: "Point",
                                    coordinates: locTwoPointLatLng,
                                },
                            }, ],
                        },
                    });

                    // Add a symbol layer
                    map.addLayer({
                        id: "points2",
                        type: "symbol",
                        source: "points2",
                        layout: {
                            "icon-image": "custom-marker2",
                            // get the title name from the source's "title" property
                            "text-field": ["get", "title"],
                            "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
                            "text-offset": [0, 1.25],
                            "text-anchor": "top",
                        },
                    });
                });

                map.addSource(
                    "polygon2",
                    createGeoJSONCircle(locTwoPointLatLng, 30.0)
                );
    
                map.addLayer({
                    id: "polygon2",
                    type: "fill",
                    source: "polygon2",
                    layout: {},
                    paint: {
                        "fill-color": "#69b6bc",
                        "fill-opacity": 0,
                    },
                });

                let loctwo = document.querySelector(".loctwo");
                setTimeout(function() {
                    loctwo.classList.add("active");
                }, 200);

                setTimeout(function() {
                    loctwo.classList.remove("active");
                }, 800);

            }

            // Riverside
            const locThreePointLatLng = [-117.401028, 33.9493029];

            function locationThree() {
                map.loadImage(mapIcon, (error, image) => {
                    if (error) throw error;
                    map.addImage("custom-marker3", image);
                    // Add a GeoJSON source with 2 points
                    map.addSource("points3", {
                        type: "geojson",
                        data: {
                            type: "FeatureCollection",
                            features: [{
                                // feature for Huntington Beach
                                type: "Feature",
                                geometry: {
                                    type: "Point",
                                    coordinates: locThreePointLatLng,
                                },
                            }, ],
                        },
                    });

                    // Add a symbol layer
                    map.addLayer({
                        id: "points3",
                        type: "symbol",
                        source: "points3",
                        layout: {
                            "icon-image": "custom-marker3",
                            // get the title name from the source's "title" property
                            "text-field": ["get", "title"],
                            "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
                            "text-offset": [0, 1.25],
                            "text-anchor": "top",
                        },
                    });
                });

                map.addSource(
                    "polygon3",
                    createGeoJSONCircle(locThreePointLatLng, 30.0)
                );
    
                map.addLayer({
                    id: "polygon3",
                    type: "fill",
                    source: "polygon3",
                    layout: {},
                    paint: {
                        "fill-color": "#a1d9d2",
                        "fill-opacity": 0,
                    },
                });

                let locthree = document.querySelector(".locthree");
                setTimeout(function() {
                    locthree.classList.add("active");
                }, 200);

                setTimeout(function() {
                    locthree.classList.remove("active");
                }, 800);

            }

             // Valley
            const locFourPointLatLng = [-118.5294178, 34.2007831];

            function locationFour() {
                map.loadImage(mapIcon, (error, image) => {
                    if (error) throw error;
                    map.addImage("custom-marker4", image);
                    // Add a GeoJSON source with 2 points
                    map.addSource("points4", {
                        type: "geojson",
                        data: {
                            type: "FeatureCollection",
                            features: [{
                                // feature for Beverly Hills
                                type: "Feature",
                                geometry: {
                                    type: "Point",
                                    coordinates: locFourPointLatLng,
                                },
                            }, ],
                        },
                    });

                    // Add a symbol layer
                    map.addLayer({
                        id: "points4",
                        type: "symbol",
                        source: "points4",
                        layout: {
                            "icon-image": "custom-marker4",
                            // get the title name from the source's "title" property
                            "text-field": ["get", "title"],
                            "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
                            "text-offset": [0, 1.25],
                            "text-anchor": "top",
                        },
                    });
                });

                map.addSource(
                    "polygon4",
                    createGeoJSONCircle(locFourPointLatLng, 30.0)
                );
    
                map.addLayer({
                    id: "polygon4",
                    type: "fill",
                    source: "polygon4",
                    layout: {},
                    paint: {
                        "fill-color": "#34658d",
                        "fill-opacity": 0,
                    },
                });

                let locfour = document.querySelector(".locfour");
                setTimeout(function() {
                    locfour.classList.add("active");
                }, 200);

                setTimeout(function() {
                    locfour.classList.remove("active");
                }, 800);

            }

             // San Gabriel
            const locFivePointLatLng = [-117.9261074, 34.071511];

            function locationFive() {
                map.loadImage(mapIcon, (error, image) => {
                    if (error) throw error;
                    map.addImage("custom-marker5", image);
                    // Add a GeoJSON source with 2 points
                    map.addSource("points5", {
                        type: "geojson",
                        data: {
                            type: "FeatureCollection",
                            features: [{
                                // feature for Beverly Hills
                                type: "Feature",
                                geometry: {
                                    type: "Point",
                                    coordinates: locFivePointLatLng,
                                },
                            }, ],
                        },
                    });

                    // Add a symbol layer
                    map.addLayer({
                        id: "points5",
                        type: "symbol",
                        source: "points5",
                        layout: {
                            "icon-image": "custom-marker5",
                            // get the title name from the source's "title" property
                            "text-field": ["get", "title"],
                            "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
                            "text-offset": [0, 1.25],
                            "text-anchor": "top",
                        },
                    });
                });

                map.addSource(
                    "polygon5",
                    createGeoJSONCircle(locFivePointLatLng, 30.0)
                );
    
                map.addLayer({
                    id: "polygon5",
                    type: "fill",
                    source: "polygon5",
                    layout: {},
                    paint: {
                        "fill-color": "#69b6bc",
                        "fill-opacity": 0,
                    },
                });

                let locfive = document.querySelector(".locfive");
                setTimeout(function() {
                    locfive.classList.add("active");
                }, 200);

                setTimeout(function() {
                    locfive.classList.remove("active");
                }, 800);

            }

             // Antelope Valley
             const locSixPointLatLng = [-118.1426083, 34.5872707];

             function locationSix() {
                 map.loadImage(mapIcon, (error, image) => {
                     if (error) throw error;
                     map.addImage("custom-marker6", image);
                     // Add a GeoJSON source with 2 points
                     map.addSource("points6", {
                         type: "geojson",
                         data: {
                             type: "FeatureCollection",
                             features: [{
                                 // feature for Beverly Hills
                                 type: "Feature",
                                 geometry: {
                                     type: "Point",
                                     coordinates: locSixPointLatLng,
                                 },
                             }, ],
                         },
                     });
 
                     // Add a symbol layer
                     map.addLayer({
                         id: "points6",
                         type: "symbol",
                         source: "points6",
                         layout: {
                             "icon-image": "custom-marker6",
                             // get the title name from the source's "title" property
                             "text-field": ["get", "title"],
                             "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
                             "text-offset": [0, 1.25],
                             "text-anchor": "top",
                         },
                     });
                 });
 
                 map.addSource(
                     "polygon6",
                     createGeoJSONCircle(locSixPointLatLng, 30.0)
                 );
     
                 map.addLayer({
                     id: "polygon6",
                     type: "fill",
                     source: "polygon6",
                     layout: {},
                     paint: {
                         "fill-color": "#a1d9d2",
                         "fill-opacity": 0,
                     },
                 });
 
                 let locsix = document.querySelector(".locsix");
                 setTimeout(function() {
                     locsix.classList.add("active");
                 }, 200);
 
                 setTimeout(function() {
                     locsix.classList.remove("active");
                 }, 800);
 
             }

             // Valencia
             const locSevenPointLatLng = [-118.5808355, 34.4068893];

             function locationSeven() {
                 map.loadImage(mapIcon, (error, image) => {
                     if (error) throw error;
                     map.addImage("custom-marker7", image);
                     // Add a GeoJSON source with 2 points
                     map.addSource("points7", {
                         type: "geojson",
                         data: {
                             type: "FeatureCollection",
                             features: [{
                                 // feature for Valencia
                                 type: "Feature",
                                 geometry: {
                                     type: "Point",
                                     coordinates: locSevenPointLatLng,
                                 },
                             }, ],
                         },
                     });
 
                     // Add a symbol layer
                     map.addLayer({
                         id: "points7",
                         type: "symbol",
                         source: "points7",
                         layout: {
                             "icon-image": "custom-marker6",
                             // get the title name from the source's "title" property
                             "text-field": ["get", "title"],
                             "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
                             "text-offset": [0, 1.25],
                             "text-anchor": "top",
                         },
                     });
                 });
 
                 map.addSource(
                     "polygon7",
                     createGeoJSONCircle(locSevenPointLatLng, 30.0)
                 );
     
                 map.addLayer({
                     id: "polygon7",
                     type: "fill",
                     source: "polygon7",
                     layout: {},
                     paint: {
                         "fill-color": "#34658d",
                         "fill-opacity": 0,
                     },
                 });
 
                 let locseven = document.querySelector(".locseven");
                 setTimeout(function() {
                     locseven.classList.add("active");
                 }, 200);
 
                 setTimeout(function() {
                     locseven.classList.remove("active");
                 }, 800);
 
             }

            function placeMarkers() {
                let locinterval
                let locindx = 1

                setTimeout(() => {
                    // call your func here
                    locinterval = setInterval(() => {
                        if (locindx == 1) {
                            locationOne()
                        }

                        if (locindx == 2) {
                            locationTwo()
                        }

                        if (locindx == 3) {
                            locationThree()
                        }

                        if (locindx == 4) {
                            locationFour()
                        }

                        if (locindx == 5) {
                            locationFive()
                        }

                        if (locindx == 6) {
                            locationSix()
                        }

                        if (locindx == 7) {
                            locationSeven()
                        }

                        locindx++
                        if (locindx >= 8) {
                            clearInterval(locinterval);

                            var bounds = new mapboxgl.LngLatBounds();
                            bounds.extend(locOnePointLatLng);
                            bounds.extend(locTwoPointLatLng);
                            bounds.extend(locThreePointLatLng);
                            bounds.extend(locFourPointLatLng);
                            bounds.extend(locFivePointLatLng);
                            bounds.extend(locSixPointLatLng);
                            bounds.extend(locSevenPointLatLng);

                           map.fitBounds(bounds, { padding: 30 });
                        }
                            
                    }, 400)
                }, 0)
            }

            placeMarkers()

        }

        var createGeoJSONCircle = function(center, radiusInKm, points) {
            if (!points) points = 64;

            var coords = {
                latitude: center[1],
                longitude: center[0],
            };

            var km = radiusInKm;

            var ret = [];
            var distanceX =
                km / (111.32 * Math.cos((coords.latitude * Math.PI) / 180));
            var distanceY = km / 110.574;

            var theta, x, y;
            for (var i = 0; i < points; i++) {
                theta = (i / points) * (2 * Math.PI);
                x = distanceX * Math.cos(theta);
                y = distanceY * Math.sin(theta);

                ret.push([coords.longitude + x, coords.latitude + y]);
            }
            ret.push(ret[0]);

            return {
                type: "geojson",
                data: {
                    type: "FeatureCollection",
                    features: [{
                        type: "Feature",
                        geometry: {
                            type: "Polygon",
                            coordinates: [ret],
                        },
                    }, ],
                },
            };
        };

        // home locations carousel

        document.getElementById("locone").addEventListener("click", (e) => {

            // feature for Dana Point
            map.setPaintProperty('polygon1', 'fill-opacity', 0.35);
            map.setPaintProperty('polygon2', 'fill-opacity', 0);
            map.setPaintProperty('polygon3', 'fill-opacity', 0);
            map.setPaintProperty('polygon4', 'fill-opacity', 0);
            map.setPaintProperty('polygon5', 'fill-opacity', 0);
            map.setPaintProperty('polygon6', 'fill-opacity', 0);
            map.setPaintProperty('polygon7', 'fill-opacity', 0);

            curLoc = 'polygon1';
           homelocationinnerwrap[0].classList.add("active");
        });

        document.getElementById("loctwo").addEventListener("click", (e) => {

            // feature for Riverside
            
            map.setPaintProperty('polygon1', 'fill-opacity', 0);
            map.setPaintProperty('polygon2', 'fill-opacity', 0.35);
            map.setPaintProperty('polygon3', 'fill-opacity', 0);
            map.setPaintProperty('polygon4', 'fill-opacity', 0);
            map.setPaintProperty('polygon5', 'fill-opacity', 0);
            map.setPaintProperty('polygon6', 'fill-opacity', 0);
            map.setPaintProperty('polygon7', 'fill-opacity', 0);

            curLoc = 'polygon2';
           homelocationinnerwrap[0].classList.add("active");

        });

        document.getElementById("locthree").addEventListener("click", (e) => {

            // feature for Huntington Beach
            
            map.setPaintProperty('polygon1', 'fill-opacity', 0);
            map.setPaintProperty('polygon2', 'fill-opacity', 0);
            map.setPaintProperty('polygon3', 'fill-opacity', 0.35);
            map.setPaintProperty('polygon4', 'fill-opacity', 0);
            map.setPaintProperty('polygon5', 'fill-opacity', 0);
            map.setPaintProperty('polygon6', 'fill-opacity', 0);
            map.setPaintProperty('polygon7', 'fill-opacity', 0);

            curLoc = 'polygon3';
           homelocationinnerwrap[0].classList.add("active");

        });

        document.getElementById("locfour").addEventListener("click", (e) => {

            // feature for Beverly Hills

            map.setPaintProperty('polygon1', 'fill-opacity', 0);
            map.setPaintProperty('polygon2', 'fill-opacity', 0);
            map.setPaintProperty('polygon3', 'fill-opacity', 0);
            map.setPaintProperty('polygon4', 'fill-opacity', 0.35);
            map.setPaintProperty('polygon5', 'fill-opacity', 0);
            map.setPaintProperty('polygon6', 'fill-opacity', 0);
            map.setPaintProperty('polygon7', 'fill-opacity', 0);

            curLoc = 'polygon4';
           homelocationinnerwrap[0].classList.add("active");

        });

        document.getElementById("locfive").addEventListener("click", (e) => {

            // feature for Beverly Hills

            map.setPaintProperty('polygon1', 'fill-opacity', 0);
            map.setPaintProperty('polygon2', 'fill-opacity', 0);
            map.setPaintProperty('polygon3', 'fill-opacity', 0);
            map.setPaintProperty('polygon4', 'fill-opacity', 0);
            map.setPaintProperty('polygon5', 'fill-opacity', 0.35);
            map.setPaintProperty('polygon6', 'fill-opacity', 0);
            map.setPaintProperty('polygon7', 'fill-opacity', 0);

            curLoc = 'polygon5';
           homelocationinnerwrap[0].classList.add("active");

        });

        document.getElementById("locsix").addEventListener("click", (e) => {

            // feature for Palmdale

            map.setPaintProperty('polygon1', 'fill-opacity', 0);
            map.setPaintProperty('polygon2', 'fill-opacity', 0);
            map.setPaintProperty('polygon3', 'fill-opacity', 0);
            map.setPaintProperty('polygon4', 'fill-opacity', 0);
            map.setPaintProperty('polygon5', 'fill-opacity', 0);
            map.setPaintProperty('polygon6', 'fill-opacity', 0.35);
            map.setPaintProperty('polygon7', 'fill-opacity', 0);

            curLoc = 'polygon6';
           homelocationinnerwrap[0].classList.add("active");

        });

        document.getElementById("locseven").addEventListener("click", (e) => {

            // feature for Valencia

            map.setPaintProperty('polygon1', 'fill-opacity', 0);
            map.setPaintProperty('polygon2', 'fill-opacity', 0);
            map.setPaintProperty('polygon3', 'fill-opacity', 0);
            map.setPaintProperty('polygon4', 'fill-opacity', 0);
            map.setPaintProperty('polygon5', 'fill-opacity', 0);
            map.setPaintProperty('polygon6', 'fill-opacity', 0);
            map.setPaintProperty('polygon7', 'fill-opacity', 0.35);

            curLoc = 'polygon7';
           homelocationinnerwrap[0].classList.add("active");

        });




        // home loca
       // var homelocationssplide = new Splide('.homelocationsplide', {
        //    direction: 'ttb',
        //    height: '100%',
         //   perPage: 5,
         //   perMove: 1,
        //    type: 'slide',
         //   drag: false,
            // classes: {
            //     arrows: 'splide__arrows homeloc-arrows',
            //     arrow : 'splide__arrow homeloc-arrow',
            //     prev  : 'splide__arrow--prev homeloc-prev',
            //     next  : 'splide__arrow--next homeloc-next',
            // },
          //  pagination: false,
       // });

        // homelocationssplide.on( 'mounted', function () {
            let homelocationsheight = jQuery(".homelocations").outerHeight()
            let box = document.querySelector('.homelocationsplide');
            let locrect = box.getBoundingClientRect();
            let locheight = 940;

            jQuery('.homemap').css({"height": locheight});
            loadHomeMap(map);
            map.on('load', function () {
                map.resize();
            });
        // } );

        // homelocationssplide.mount();

    };



    // mapbox two

    var homelocationstwo = document.querySelectorAll('.homelocationstwo');


    if (homelocationstwo.length > 0) {
    
    
            mapboxgl.accessToken =
                "pk.eyJ1IjoidXBwZXJob3VzZSIsImEiOiJjazFpOHdzanoxaW5zM21wZGx2ZHRqM2R4In0.Ahjx7eaAqipeYaYLYCWjZA";
            const map = new mapboxgl.Map({
                container: "maptwo",
                // Choose from Mapbox's core styles, or make your own style with Mapbox Studio
                style: "mapbox://styles/mapbox/light-v11",
                center: [-117.906454, 33.654739],
                zoom: 8.8,
                interactive: false,
            });
            map.scrollZoom.disable();
    
    
            map.on("load", () => {

                // map loaded
    
            });

            map.on('click', function(e) {

        
                const bbox = [
                    [e.point.x - 5, e.point.y - 5],
                    [e.point.x + 5, e.point.y + 5]
                    ];

                    // dana point
                    const pointsOne = map.queryRenderedFeatures(bbox, {
                        layers: ['points1']
                    });

                    if (pointsOne.length == 1) {
                        window.location.href = "/dana-point/";
                    }

                    // Huntington Beach
                    const pointsTwo = map.queryRenderedFeatures(bbox, {
                        layers: ['points2']
                    });

                    if (pointsTwo.length == 1) {
                        window.location.href = "/locations-huntington-beach/";
                    }

                    // Riverside
                    const pointsThree = map.queryRenderedFeatures(bbox, {
                        layers: ['points3']
                    });

                    if (pointsThree.length == 1) {
                        window.location.href = "/locations-riverside/";
                    }

                    // Valley
                    const pointsFour = map.queryRenderedFeatures(bbox, {
                        layers: ['points4']
                    });

                    if (pointsFour.length == 1) {
                        window.location.href = "/san-fernando-valley/";
                    }

                    // San Gabriel
                    const pointsFive = map.queryRenderedFeatures(bbox, {
                        layers: ['points5']
                    });

                    if (pointsFive.length == 1) {
                        window.location.href = "/locations-san-gabriel-valley/";
                    }

                    // Antelope Valley
                    const pointsSix = map.queryRenderedFeatures(bbox, {
                        layers: ['points6']
                    });

                    if (pointsSix.length == 1) {
                        window.location.href = "/locations-antelope-valley/";
                    }

                    // Valencia
                    const pointsSeven = map.queryRenderedFeatures(bbox, {
                        layers: ['points7']
                    });

                    if (pointsSeven.length == 1) {
                        window.location.href = "/locations-valencia/";
                    }

        
            });
    
        
            loadMapTwo(map);
    
            function loadMapTwo(map) {
    
                // Dana Point
                const locOnePointLatLng = [-117.7231871, 33.4943349];
    
                function locationOne() {
                    map.loadImage(mapIcon, (error, image) => {
                        if (error) throw error;
                        map.addImage("custom-marker1", image);
                        // Add a GeoJSON source with 2 points
                        map.addSource("points1", {
                            type: "geojson",
                            data: {
                                type: "FeatureCollection",
                                features: [{
                                    // feature for Dana Point
                                    type: "Feature",
                                    geometry: {
                                        type: "Point",
                                        coordinates: locOnePointLatLng,
                                    },
                                }, ],
                            },
                        });
    
                        // Add a symbol layer
                        map.addLayer({
                            id: "points1",
                            "interactive": true,
                            type: "symbol",
                            source: "points1",
                            layout: {
                                "icon-image": "custom-marker1",
                                // get the title name from the source's "title" property
                                "text-field": ["get", "title"],
                                "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
                                "text-offset": [0, 1.25],
                                "text-anchor": "top",
                            },
                        });
                    });
    
                    map.addSource(
                        "polygon1",
                        createGeoJSONCircle(locOnePointLatLng, 30.0)
                    );
        
                    map.addLayer({
                        id: "polygon1",
                        type: "fill",
                        source: "polygon1",
                        layout: {},
                        paint: {
                            "fill-color": "#34658d",
                            "fill-opacity": 0,
                        },
                    });
    
                }
    
                // Huntington Beach
                const locTwoPointLatLng = [-117.9928712, 33.7014531];
    
                function locationTwo() {
                    map.loadImage(mapIcon, (error, image) => {
                        if (error) throw error;
                        map.addImage("custom-marker2", image);
                        // Add a GeoJSON source with 2 points
                        map.addSource("points2", {
                            type: "geojson",
                            data: {
                                type: "FeatureCollection",
                                features: [{
                                    // feature for Huntington Beach
                                    type: "Feature",
                                    geometry: {
                                        type: "Point",
                                        coordinates: locTwoPointLatLng,
                                    },
                                }, ],
                            },
                        });
    
                        // Add a symbol layer
                        map.addLayer({
                            id: "points2",
                            type: "symbol",
                            source: "points2",
                            layout: {
                                "icon-image": "custom-marker2",
                                // get the title name from the source's "title" property
                                "text-field": ["get", "title"],
                                "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
                                "text-offset": [0, 1.25],
                                "text-anchor": "top",
                            },
                        });
                    });
    
                    map.addSource(
                        "polygon2",
                        createGeoJSONCircle(locTwoPointLatLng, 30.0)
                    );
        
                    map.addLayer({
                        id: "polygon2",
                        type: "fill",
                        source: "polygon2",
                        layout: {},
                        paint: {
                            "fill-color": "#69b6bc",
                            "fill-opacity": 0,
                        },
                    });
    
                }
    
                // Riverside
                const locThreePointLatLng = [-117.401028, 33.9493029];
    
                function locationThree() {
                    map.loadImage(mapIcon, (error, image) => {
                        if (error) throw error;
                        map.addImage("custom-marker3", image);
                        // Add a GeoJSON source with 2 points
                        map.addSource("points3", {
                            type: "geojson",
                            data: {
                                type: "FeatureCollection",
                                features: [{
                                    // feature for Huntington Beach
                                    type: "Feature",
                                    geometry: {
                                        type: "Point",
                                        coordinates: locThreePointLatLng,
                                    },
                                }, ],
                            },
                        });
    
                        // Add a symbol layer
                        map.addLayer({
                            id: "points3",
                            type: "symbol",
                            source: "points3",
                            layout: {
                                "icon-image": "custom-marker3",
                                // get the title name from the source's "title" property
                                "text-field": ["get", "title"],
                                "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
                                "text-offset": [0, 1.25],
                                "text-anchor": "top",
                            },
                        });
                    });
    
                    map.addSource(
                        "polygon3",
                        createGeoJSONCircle(locThreePointLatLng, 30.0)
                    );
        
                    map.addLayer({
                        id: "polygon3",
                        type: "fill",
                        source: "polygon3",
                        layout: {},
                        paint: {
                            "fill-color": "#a1d9d2",
                            "fill-opacity": 0,
                        },
                    });
    
                }
    
                 // Valley
                const locFourPointLatLng = [-118.5294178, 34.2007831];
    
                function locationFour() {
                    map.loadImage(mapIcon, (error, image) => {
                        if (error) throw error;
                        map.addImage("custom-marker4", image);
                        // Add a GeoJSON source with 2 points
                        map.addSource("points4", {
                            type: "geojson",
                            data: {
                                type: "FeatureCollection",
                                features: [{
                                    // feature for Beverly Hills
                                    type: "Feature",
                                    geometry: {
                                        type: "Point",
                                        coordinates: locFourPointLatLng,
                                    },
                                }, ],
                            },
                        });
    
                        // Add a symbol layer
                        map.addLayer({
                            id: "points4",
                            type: "symbol",
                            source: "points4",
                            layout: {
                                "icon-image": "custom-marker4",
                                // get the title name from the source's "title" property
                                "text-field": ["get", "title"],
                                "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
                                "text-offset": [0, 1.25],
                                "text-anchor": "top",
                            },
                        });
                    });
    
                    map.addSource(
                        "polygon4",
                        createGeoJSONCircle(locFourPointLatLng, 30.0)
                    );
        
                    map.addLayer({
                        id: "polygon4",
                        type: "fill",
                        source: "polygon4",
                        layout: {},
                        paint: {
                            "fill-color": "#34658d",
                            "fill-opacity": 0,
                        },
                    });
    
                }
    
                 // San Gabriel
                const locFivePointLatLng = [-117.9261074, 34.071511];
    
                function locationFive() {
                    map.loadImage(mapIcon, (error, image) => {
                        if (error) throw error;
                        map.addImage("custom-marker5", image);
                        // Add a GeoJSON source with 2 points
                        map.addSource("points5", {
                            type: "geojson",
                            data: {
                                type: "FeatureCollection",
                                features: [{
                                    // feature for Beverly Hills
                                    type: "Feature",
                                    geometry: {
                                        type: "Point",
                                        coordinates: locFivePointLatLng,
                                    },
                                }, ],
                            },
                        });
    
                        // Add a symbol layer
                        map.addLayer({
                            id: "points5",
                            type: "symbol",
                            source: "points5",
                            layout: {
                                "icon-image": "custom-marker5",
                                // get the title name from the source's "title" property
                                "text-field": ["get", "title"],
                                "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
                                "text-offset": [0, 1.25],
                                "text-anchor": "top",
                            },
                        });
                    });
    
                    map.addSource(
                        "polygon5",
                        createGeoJSONCircle(locFivePointLatLng, 30.0)
                    );
        
                    map.addLayer({
                        id: "polygon5",
                        type: "fill",
                        source: "polygon5",
                        layout: {},
                        paint: {
                            "fill-color": "#69b6bc",
                            "fill-opacity": 0,
                        },
                    });

                }

                // Antelope Valley
                const locSixPointLatLng = [-118.1426083, 34.5872707];
    
                function locationSix() {
                    map.loadImage(mapIcon, (error, image) => {
                        if (error) throw error;
                        map.addImage("custom-marker6", image);
                        // Add a GeoJSON source with 2 points
                        map.addSource("points6", {
                            type: "geojson",
                            data: {
                                type: "FeatureCollection",
                                features: [{
                                    // feature for Beverly Hills
                                    type: "Feature",
                                    geometry: {
                                        type: "Point",
                                        coordinates: locSixPointLatLng,
                                    },
                                }, ],
                            },
                        });
    
                        // Add a symbol layer
                        map.addLayer({
                            id: "points6",
                            type: "symbol",
                            source: "points6",
                            layout: {
                                "icon-image": "custom-marker6",
                                // get the title name from the source's "title" property
                                "text-field": ["get", "title"],
                                "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
                                "text-offset": [0, 1.25],
                                "text-anchor": "top",
                            },
                        });
                    });
    
                    map.addSource(
                        "polygon6",
                        createGeoJSONCircle(locFivePointLatLng, 30.0)
                    );
        
                    map.addLayer({
                        id: "polygon6",
                        type: "fill",
                        source: "polygon6",
                        layout: {},
                        paint: {
                            "fill-color": "#69b6bc",
                            "fill-opacity": 0,
                        },
                    });
    
                }

                // Valencia
                const locSevenPointLatLng = [-118.5808355, 34.4068893];
    
                function locationSeven() {
                    map.loadImage(mapIcon, (error, image) => {
                        if (error) throw error;
                        map.addImage("custom-marker7", image);
                        // Add a GeoJSON source with 2 points
                        map.addSource("points7", {
                            type: "geojson",
                            data: {
                                type: "FeatureCollection",
                                features: [{
                                    // feature for Dana Point
                                    type: "Feature",
                                    geometry: {
                                        type: "Point",
                                        coordinates: locSevenPointLatLng,
                                    },
                                }, ],
                            },
                        });
    
                        // Add a symbol layer
                        map.addLayer({
                            id: "points7",
                            "interactive": true,
                            type: "symbol",
                            source: "points7",
                            layout: {
                                "icon-image": "custom-marker1",
                                // get the title name from the source's "title" property
                                "text-field": ["get", "title"],
                                "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
                                "text-offset": [0, 1.25],
                                "text-anchor": "top",
                            },
                        });
                    });
    
                    map.addSource(
                        "polygon7",
                        createGeoJSONCircle(locOnePointLatLng, 30.0)
                    );
        
                    map.addLayer({
                        id: "polygon7",
                        type: "fill",
                        source: "polygon7",
                        layout: {},
                        paint: {
                            "fill-color": "#34658d",
                            "fill-opacity": 0,
                        },
                    });
    
                }
    
                function placeMarkers() {
                    let locinterval
                    let locindx = 1
    
                    setTimeout(() => {
                        // call your func here
                        locinterval = setInterval(() => {
                            if (locindx == 1) {
                                locationOne()
                            }
    
                            if (locindx == 2) {
                                locationTwo()
                            }
    
                            if (locindx == 3) {
                                locationThree()
                            }
    
                            if (locindx == 4) {
                                locationFour()
                            }
    
                            if (locindx == 5) {
                                locationFive()
                            }

                            if (locindx == 6) {
                                locationSix()
                            }

                            if (locindx == 7) {
                                locationSeven()
                            }
    
                            locindx++
                            if (locindx >= 8) {
                                clearInterval(locinterval);
    
                                var bounds = new mapboxgl.LngLatBounds();
                                bounds.extend(locOnePointLatLng);
                                bounds.extend(locTwoPointLatLng);
                                bounds.extend(locThreePointLatLng);
                                bounds.extend(locFourPointLatLng);
                                bounds.extend(locFivePointLatLng);
                                bounds.extend(locSixPointLatLng);
                                bounds.extend(locSevenPointLatLng);
    
                                map.fitBounds(bounds, { padding: 100 });
                            }
                                
                        }, 400)
                    }, 0)
                }
    
                placeMarkers()
    
            }
    
            var createGeoJSONCircle = function(center, radiusInKm, points) {
                if (!points) points = 64;
    
                var coords = {
                    latitude: center[1],
                    longitude: center[0],
                };
    
                var km = radiusInKm;
    
                var ret = [];
                var distanceX =
                    km / (111.32 * Math.cos((coords.latitude * Math.PI) / 180));
                var distanceY = km / 110.574;
    
                var theta, x, y;
                for (var i = 0; i < points; i++) {
                    theta = (i / points) * (2 * Math.PI);
                    x = distanceX * Math.cos(theta);
                    y = distanceY * Math.sin(theta);
    
                    ret.push([coords.longitude + x, coords.latitude + y]);
                }
                ret.push(ret[0]);
    
                return {
                    type: "geojson",
                    data: {
                        type: "FeatureCollection",
                        features: [{
                            type: "Feature",
                            geometry: {
                                type: "Polygon",
                                coordinates: [ret],
                            },
                        }, ],
                    },
                };
            };
    };
    

    // main carousel

    var homesplide = document.querySelectorAll('.homesplide');

    if (homesplide.length > 0) {
        var homevertsplide = new Splide('.homesplide', {
            direction: 'ttb',
            height: '550px',
            perPage: 5,
            perMove: 1,
            breakpoints: {
                850: {
                    perPage: 1,
                    height: '280px',
                },
            },
            type: 'loop',
            classes: {
                arrows: 'splide__arrows homevert-arrows',
                arrow: 'splide__arrow homevert-arrow',
                prev: 'splide__arrow--prev homevert-prev',
                next: 'splide__arrow--next homevert-next',
            },
            pagination: false,
        });

        homevertsplide.mount();

        // desktop close menu button
        const vertlinks = document.querySelectorAll('.vertlink');

        vertlinks.forEach(el => el.addEventListener('click', event => {
            let vertlinkid = event.target.parentElement.id;
            vertlinkid = vertlinkid.replace('vert', '');
            vertlinkid = Number(vertlinkid) - 1;

            homevertsplide.go(vertlinkid);

        }));
    }

    // comparison carousel

    var comparisonsplide = document.querySelectorAll('.comparisonsplide');

    if (comparisonsplide.length > 0) {
        var comparisonvertsplide = new Splide('.comparisonsplide', {
            direction: 'ttb',
            height: '430px',
            perPage: 3,
            perMove: 1,
            breakpoints: {
                850: {
                    perPage: 1,
                    height: '280px',
                },
            },
            type: 'loop',
            classes: {
                arrows: 'splide__arrows homevert-arrows',
                arrow: 'splide__arrow homevert-arrow',
                prev: 'splide__arrow--prev homevert-prev',
                next: 'splide__arrow--next homevert-next',
            },
            pagination: false,
        });

        comparisonvertsplide.mount();

        // desktop close menu button
        const vertlinks = document.querySelectorAll('.vertlink');

        vertlinks.forEach(el => el.addEventListener('click', event => {
            let vertlinkid = event.target.parentElement.id;
            vertlinkid = vertlinkid.replace('vert', '');
            vertlinkid = Number(vertlinkid) - 1;

            comparisonvertsplide.go(vertlinkid);

        }));
    }

    var medicalhealthwrap = document.querySelectorAll('.medicalhealthimg');
    const classnames = ['medone', 'medtwo', 'medthree', 'medfour', 'medfive', 'medsix']

    if (medicalhealthwrap.length > 0) {

        const initialDelay = 0.3
        const delay = 1
        let interval
        let indx = 0
        let medicalinit = true

        window.onscroll = function(e) {
            // called when the window is scrolled.  
            let testMedicalPos = isScrolledIntoView(medicalhealthwrap);

            if (testMedicalPos == true && medicalinit == true) {

                medicalinit = false

                setTimeout(() => {
                    // call your func here
                    interval = setInterval(() => {
                        let calloutel = document.getElementsByClassName(classnames[indx])[0];
                        calloutel.classList.add("active");
                        indx++
                        if (indx >= 6) {
                            clearInterval(interval);
                            closeMedCallouts();
                        }

                    }, delay * 500)
                }, 100)

            }
        }
    }

    function closeMedCallouts() {
        const closedelay = 1
        let closeinterval
        let closeindx = 0

        setTimeout(() => {

            closeinterval = setInterval(() => {
                let calloutel = document.getElementsByClassName(classnames[closeindx])[0];
                calloutel.classList.remove("active");
                closeindx++
                if (closeindx >= 6)
                    clearInterval(closeinterval);
            }, closedelay * 300)
        }, 3000)
    }

    var medcallouts = document.querySelectorAll('.medcirc');

    medcallouts.forEach(el => el.addEventListener('click', event => {
        event.currentTarget.classList.toggle("active");
    }));

    // blog list
    let currentPage = 1;
    window.currentCat = '';
    const domain = window.location.hostname;

    function showMore() {
        document.getElementById("showmore").addEventListener("click", (e) => {

            e.preventDefault();
    
            currentPage++;
    
            // Creating data 
            let requestDataFirst = {
                action: "weichie_load_more",
                locales: 'localestester',
                terms: 'termstest',
                paged: currentPage,
                cat: window.currentCat,
                nonce: 'test nonce'
            };
                
            // Initiating AJAX request for start of places list - limit 6
            fetch('https://'+domain+'/wp-admin/admin-ajax.php', {
                method:"post",
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams(requestDataFirst).toString(),
            }).then(function(response) {
                return response.text();
            }).then(function(response) {
                if (response == 0) {
                    document.querySelector(".bloglistmoreinner").innerHTML = '';
                } else {
                    document.querySelector('.bloglistinner .blogitem:last-child').insertAdjacentHTML("afterend", response);
                    showBlogMore();
                }
            });
    
        });
    }

    const bloglistouter = document.querySelector('.bloglistouter');

    if (bloglistouter) {
        showMore();
    }

    

    const partnerform = document.getElementById('partnerform');

    if (partnerform) {

        var partnerlinks = document.querySelectorAll('.partnerclick');

        partnerlinks.forEach(el => el.addEventListener('click', event => {
            event.preventDefault()
            jQuery('html, body').animate({ scrollTop: jQuery('#partnerform').offset().top }, 'slow');
        }));

    }

    // catlinks
    const catlinks = document.querySelectorAll('.catlink');

    catlinks.forEach(el => el.addEventListener('click', event => {

        event.preventDefault();

        let catlink = event.target.getAttribute("href");
        catlink = catlink.replace('#', '');
        let blogcount = event.target.getAttribute("data-catcount");
        window.currentCat = catlink;

        // Creating data 
        let requestCatDataFirst = {
            action: "weichie_load_more",
            cat: window.currentCat,
            paged: 1,
            nonce: 'test nonce'
        };
            
        // Initiating AJAX request for start of places list - limit 6
        fetch('https://'+domain+'/wp-admin/admin-ajax.php', {
            method:"post",
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams(requestCatDataFirst).toString(),
        }).then(function(response) {
            return response.text();
        }).then(function(response) {

            document.querySelector(".bloglistinner").innerHTML = response;
            showBlogMore();
            currentPage = 1;
            
        });

    }));

    // blog more
    function showBlogMore() {

        let windowcatid = window.currentCat;
        if (windowcatid == '') {
            windowcatid = '0';
        }
        let blogcount = document.getElementById('cat'+windowcatid).getAttribute("data-catcount");
        let curitems = document.querySelectorAll('.blogitem').length;

        // console.log(blogcount);
        // console.log(curitems);
        if (blogcount > 3 && curitems < blogcount) {
            document.querySelector(".bloglistmoreinner").innerHTML = '<button id="showmore" class="sitebutton fatwide green">Show More</button>';
            showMore();
        } else {
            document.querySelector(".bloglistmoreinner").innerHTML = '';
        }

    }

    // Event Popup
    const eventpopup = document.getElementById('eventpopup');

    if (eventpopup) {

        let eventpopup = Cookies.get('eventpopup');

        if (eventpopup == undefined) {
          Cookies.set('eventpopup', 1)
          Fancybox.show([{ src: "#eventpopup", type: "inline" }]);
        }

        const pillarsbtn = document.getElementById('pillarsbtn');

        pillarsbtn.addEventListener("click", (e) => {

            jQuery('html, body').animate({ scrollTop: jQuery('#pillars').offset().top - 200 }, 'slow');
            Fancybox.close();
            e.preventDefault();
                
        });

    }


    const isElementXPercentInViewport = function(funcel, percentVisible=0.5) {
        const el = funcel[0];
        
        let
            rect = el.getBoundingClientRect(),
            windowHeight = (window.innerHeight || document.documentElement.clientHeight);

        return !(
            Math.floor(100 - (((rect.top >= 0 ? 0 : rect.top) / +-rect.height) * 100)) < percentVisible ||
            Math.floor(100 - ((rect.bottom - windowHeight) / rect.height) * 100) < percentVisible
        )
      };

    // check if element is in view
    function isScrolledIntoView(elem) {

        // const el = element[0];
        // const r = el.getBoundingClientRect();
        // const vw = document.documentElement.clientWidth;
        // const vh = document.documentElement.clientHeight;
        // const inViewX = (r.left > 0 && r.left < vw) || (r.right < vw && r.right > 0);
        // const inViewY = (r.top > 0 && r.top < vh) || (r.bottom < vh && r.bottom > 0);
        // return inViewX && inViewY;

        var docViewTop = jQuery(window).scrollTop();
        var docViewBottom = docViewTop + jQuery(window).height() + 500;

        var elemTop = jQuery(elem).offset().top;
        var elemBottom = elemTop + jQuery(elem).height();

        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }

    function isScrolledMobIntoView(elem) {
        var docHeight = jQuery(document).height();
        var docViewTop = jQuery(window).scrollTop();
        var docViewBottom = docViewTop + jQuery(window).height() + 1000;

        var elemTop = jQuery(elem).offset().top;
        var elemBottom = elemTop + jQuery(elem).height();

        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }

    // video links

    var videolinks = document.querySelectorAll('.videolink');

    videolinks.forEach(setVideoLink);

    function setVideoLink(el) {
       let videolinkel = el;
       videolinkel.addEventListener("click", (e) => {

        let videolink = videolinkel.getAttribute("href");
            Fancybox.show([{
                src: videolink,
                type: "video",
                ratio: 16 / 10,
                width: 900,
                height: 506,
                youtube: {
                    autoplay: 0
                },
                vimeo: {
                    autoplay: 0
                },
            }, ]);

            e.preventDefault();
            
       });
    }


});


const locationmap = document.getElementById('locationmap');

if (locationmap) {
    window.initMap = async function(){

        const locationsarray = [
            { lat: 34.0714701, lng: -117.9235736 }, // San Gabriel Valley
            { lat: 33.494338, lng: -117.720640 }, // Dana Point
            { lat: 33.701466, lng: -117.990421 }, // Huntington Beach
            { lat: 33.949302, lng: -117.398450 }, // Riverside
            { lat: 34.200814, lng: -118.526751 }, // Reseda
            { lat: 34.5872707, lng: -118.1426083 }, // Antelope Valley
            { lat: 34.4067611, lng: -118.5784806 }, // Valencia
            { lat: 35.3546407, lng: -119.1020583 } // Bakersfield
        ];

        let myLatLng;

        if (locationmap.classList.contains("sangabriel")) {
            myLatLng = locationsarray[0];
        } else if (locationmap.classList.contains("danapoint")) {
            myLatLng = locationsarray[1];
        } else if (locationmap.classList.contains("huntingtonbeach")) {
            myLatLng = locationsarray[2];
        } else if (locationmap.classList.contains("riverside")) {
            myLatLng = locationsarray[3];
        } else if (locationmap.classList.contains("reseda")) {
            myLatLng = locationsarray[4];
        } else if (locationmap.classList.contains("antelopevalley")) {
            myLatLng = locationsarray[5];
        } else if (locationmap.classList.contains("valencia")) {
            myLatLng = locationsarray[6];
        } else if (locationmap.classList.contains("bakersfield")) {
            myLatLng = locationsarray[7];
        }


        const styles = {
            default: [],
            hide: [
                    {
                        featureType: "poi.medical",
                        elementType: "labels.icon",
                        stylers: [{ visibility: "off" }],
                    },
                    {
                        featureType: "poi.medical",
                        elementType: "labels.text",
                        stylers: [{ visibility: "off" }],
                    },
                    {
                        featureType: "poi.business",
                        elementType: "labels.icon",
                        stylers: [{ visibility: "off" }],
                    },
                    {
                        featureType: "poi.business",
                        elementType: "labels.text",
                        stylers: [{ visibility: "off" }],
                    },
            ],
        };
        const locmap = new google.maps.Map(document.getElementById("locationmap"), {
            zoom: 17,
            styles: styles["hide"],
            center: myLatLng,
        });
    
        const image = "https://dentalimplantsgps.com/wp-content/themes/bridge-child/resources/images/gps_map_icon_2.png";
    
        const beachMarker = new google.maps.Marker({
          position: myLatLng,
          map: locmap,
          icon: image,
        });
    
    }

}
